import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ShareEmailRequest } from '@root/shared-report-platform/models/share-email.model';
import { Email } from '@store/search-board/search-board.model';

export type SendEmailRequest = Email | ShareEmailRequest;

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  constructor(private readonly httpClient: HttpClient) {
  }

  public send(email: SendEmailRequest): Observable<string> {
    return this.httpClient.post<string>('/api/send-email', email);
  }

}
